export type Recognition = {
 lang:string; continuous:boolean; interimResults:boolean;
 onresult:((event:{results:ArrayLike<ArrayLike<{transcript:string}>>})=>void)|null;
 onerror:((event:{error:string})=>void)|null;
 onend:(()=>void)|null;
 start:()=>void; stop:()=>void; abort:()=>void;
};
export type RecognitionConstructor = new()=>Recognition;
export function recognitionConstructor():RecognitionConstructor|undefined {
 const browser=window as unknown as {SpeechRecognition?:RecognitionConstructor;webkitSpeechRecognition?:RecognitionConstructor};
 return browser.SpeechRecognition??browser.webkitSpeechRecognition;
}
export function startDictation(ctor:RecognitionConstructor, draft:string, lang:string, callbacks:{text:(text:string)=>void;error:(text:string)=>void;end:()=>void}) {
 const recognition=new ctor();
 let active=true;
 recognition.lang=lang;recognition.continuous=true;recognition.interimResults=true;
 recognition.onresult=event=>{
  if(!active)return;
  // Results contain the entire session, including revised interim words.
  const spoken=Array.from(event.results,result=>result[0]?.transcript??'').join(' ').trim();
  callbacks.text(spoken?`${draft}${draft&&!/\s$/.test(draft)?' ':''}${spoken}`:draft);
 };
 const finish=()=>{if(!active)return;active=false;callbacks.end();};
 recognition.onend=finish;
 recognition.onerror=event=>{
  if(!active)return;
  const messages:Record<string,string>={
   'not-allowed':'Allow microphone access in your browser’s site settings, then try again.',
   'service-not-allowed':'Voice input is unavailable in this browser. You can type your message or try another browser.',
   'audio-capture':'Connect a microphone and check your device’s microphone settings.',
   'no-speech':'I didn’t catch that. Tap the microphone and try speaking again.',
   network:'Voice input needs a working connection. Check your connection and try again.',
  };
  if(event.error!=='aborted')callbacks.error(messages[event.error]??'Voice input couldn’t start. Try again or type your message.');
  finish();recognition.abort();
 };
 try{recognition.start();}catch{callbacks.error('Voice input couldn’t start. Check microphone access and try again.');finish();}
 return {
  stop:()=>{if(active)recognition.stop();},
  cancel:()=>{if(!active)return;active=false;recognition.onresult=null;recognition.onerror=null;recognition.onend=null;recognition.abort();callbacks.end();},
 };
}
